import { filter, isNil, isNumber } from '@antv/util';
import extended from '../util/extended';
/**
 * è®¡ç®åç±» ticks
 * @param cfg åº¦éçéç½®é¡¹
 * @returns è®¡ç®åç ticks
 */
export default function calculateCatTicks(cfg) {
    var values = cfg.values, tickInterval = cfg.tickInterval, tickCount = cfg.tickCount;
    var ticks = values;
    if (isNumber(tickInterval)) {
        return filter(ticks, function (__, i) { return i % tickInterval === 0; });
    }
    var min = cfg.min, max = cfg.max;
    if (isNil(min)) {
        min = 0;
    }
    if (isNil(max)) {
        max = values.length - 1;
    }
    if (isNumber(tickCount) && tickCount < max - min) {
        // ç®åè¿æ»¤ï¼é¨åæåµä¸å°æ°çåæ°ä¹å¯ä»¥æ¯æ´æ°
        // tslint:disable-next-line: no-shadowed-variable
        var ticks_1 = extended(min, max, tickCount, false, [1, 2, 5, 3, 4, 7, 6, 8, 9]).ticks;
        var valid = filter(ticks_1, function (tick) { return tick >= min && tick <= max; });
        return valid.map(function (index) { return values[index]; });
    }
    return values.slice(min, max + 1);
}
//# sourceMappingURL=cat.js.map